import React from 'react';

const lineStyle = {
  stroke: '#555555',
  strokeWidth: 1,
  strokeLinecap: 'round'
};

const ResizerIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <line x1="10" y1="0" x2="10" y2="20" style={lineStyle} />
    </svg>
  );
};

export default ResizerIcon;
